import { render, staticRenderFns } from "./WarehouseEdit.vue?vue&type=template&id=b361c148&scoped=true&"
import script from "./WarehouseEdit.vue?vue&type=script&lang=js&"
export * from "./WarehouseEdit.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseEdit.vue?vue&type=style&index=0&id=b361c148&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b361c148",
  null
  
)

export default component.exports